import { HeaderLayout } from "@/components/_layout/header-layout";
import { Link } from "@/components/navigation-controls/link";
import { UserFavoriteButton } from "@/domain/user/components/user-favorite-button";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { ProjectIcon } from "../components/project-icons";

export function MyProjectsPage() {
  const { currentWorkspace } = useCurrentWorkspaceContext();

  return (
    <div className="flex h-full max-h-full flex-col overflow-y-hidden">
      <HeaderLayout showNavigationControls={true}>
        <div className="flex flex-row items-center gap-2">
          <Link to={`/${currentWorkspace.workspaceUrl}/my-projects`} className="flex flex-row items-center">
            <ProjectIcon className="mr-2 h-3 w-3 text-foreground" />
            <span className="flex flex-row items-center">Meine Projekte</span>
          </Link>
          <UserFavoriteButton pageName="Meine Projekte" />
        </div>
      </HeaderLayout>
    </div>
  );
}
